import { downloadImage } from "@/utils/Image";
import Logo from "./logo.png";
import { measureTextSize, CanvasBuilder } from "@/utils/Canvas";

export const LOGO_IMAGE_SIZE = { width: 128, height: 128 };

export class LogoDrawer {
  /**
   *
   * @param {Object} [options]
   * @param {String} [options.type='image'] 'image', 'dataurl' or 'blob'
   */
  static async create(options = {}) {
    const image = await downloadImage(Logo, {
      type: options.type || "image"
    });

    const text = "SRSAC Govt. of Arunachal Pradesh";
    const font = "18px serif";
    const textSize = measureTextSize(text, font);

    const canvasSize = {
      width: Math.max(image.width, textSize.width),
      height: image.height + 10 + textSize.height
    };

    return CanvasBuilder.create(canvasSize.width, canvasSize.height)
      .drawImage(image, {
        top: 0,
        left: canvasSize.width / 2 - image.width / 2
      })
      .drawText(
        text,
        {
          x: 0,
          y: image.height + 10
        },
        {
          textBaseline: "bottom",
          textAlign: "left",
          font
        }
      )
      .toCanvas();
  }
}
